<template>
    <div class="input-row" :class="{ error }" :style="getStyle">
        <label> <slot name="label"></slot> <span v-if="required" class="required">*</span> </label>
        <main>
            <slot name="input"></slot> <span class="append-text" v-if="appendText">{{ appendText }}</span>
        </main>
        <div class="error-message" v-show="error">{{ error }}</div>
    </div>
</template>

<script>
export default {
    name: "BaseInput",
    props: {
        required: {
            type: Boolean,
            default: false,
            required: false
        },
        error: {
            default: undefined,
            required: false
        },
        appendText: {
            type: String,
            required: false,
            default: null
        },
        labelWidth: {
            type: Number,
            required: false,
            default: null
        }
    },
    computed: {
        getStyle() {
            let style = {};
            if (this.labelWidth) {
                style = {
                    "grid-template-columns": this.labelWidth + "px auto auto"
                };
            }

            return style;
        }
    }
};
</script>

<style scoped lang="scss">
@import "../../../assets/css/themes";
@import "../../../assets/css/media";

.input-row {
    display: grid;
    vertical-align: middle;
    grid-template-columns: 1.2fr 1.5fr 0.8fr;
    align-items: center;
    grid-column-gap: 20px;
    @include sm {
        grid-template-columns: repeat(1, 1fr);
        grid-row-gap: 10px;
    }

    label {
        font-family: Roboto, Sans-Serif;
        font-weight: bold;
        font-size: 1.19em;
    }
    &.error .error-message,
    &.error .required {
        color: $error-color;
        font-style: italic;
        text-transform: initial;
    }

    span.append-text {
        font-weight: normal;
        text-transform: none;
    }
}
</style>



// WEBPACK FOOTER //
// BaseInput.vue?26e5a9d7